import React from 'react';
import './styles.css';
import { WalletIcon } from '../../../assets/icons/Wallet.icon';
import { ArrowDownIcon } from '../../../assets/icons/ArrowDown.icon';

export const StatusCreditCoupon = (props) => {
  const amount_used = props.creditCoupon.amount_used || 0;
  const remaining_balance = props.creditCoupon.remaining_balance || 0;
  const createdAtformatted = new Date(props.createdAt).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="credit-summary-card">
      <div className="card-header">
        <WalletIcon />
        <h2 className="card-title">Resumo dos créditos</h2>
      </div>

      <div className="transaction-container">
        <div className="transaction-item">
          <div className="transaction-info">
            <div className="icon-wrapper">
              <ArrowDownIcon />
            </div>
            <div className="transaction-details">
              <span className="transaction-name">Saldo utilizado</span>
              <span className="transaction-date">{createdAtformatted}</span>
            </div>
          </div>
          <span className="transaction-amount">
            {amount_used.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
        </div>
      </div>

      <hr className="divider" />

      <div className="card-footer">
        <span className="footer-label">Saldo disponível</span>
        <span className="footer-value">
          {remaining_balance.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}
        </span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/purchase_status/status_credit_coupon/index.jsx